<template>
  <el-dropdown-item v-if="searchActive && isLoading" class="no-hover">
    <loading-placeholder :lines="3" />
  </el-dropdown-item>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DdGlobalSearchLoading',
  props: {
    /**
     * Activate search
     */
    searchActive: {
      type: Boolean,
      required: true,
    },
    /**
     * Activate search
     */
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
})
</script>
